export enum EnumOccupency {
    PrimaryResidence = "Primary Residence",
    SecondHome = "Second Home",
    Investor = "Investment"
}
